
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/--roboneo/flow_share",
      function () {
        return require("private-next-pages/--roboneo/flow_share/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/--roboneo/flow_share"])
      });
    }
  